import { z } from 'zod';
import { InteractionProvider } from '../index.js';
// e-Boks Event Types
// Failed event data
export const EBoksFailedEventDataSchema = z.object({
    provider: z.literal(InteractionProvider.EBoks),
    bronzeData: z.null(),
});
// Delivered event data
export const EBoksDeliveredEventDataSchema = z.object({
    provider: z.literal(InteractionProvider.EBoks),
    bronzeData: z.null(),
});
//# sourceMappingURL=e-boks.js.map